export const levelSettings = {
  VeryHigh: { name: 'VeryHigh', tag: 'very-high', opacityColor: 'ff' },
  High: { name: 'High', tag: 'high', opacityColor: 'df' },
  Medium: { name: 'Medium', tag: 'medium', opacityColor: 'bf' },
  Low: { name: 'Low', tag: 'low', opacityColor: '7f' },
  VeryLow: { name: 'VeryLow', tag: 'very-low', OpacityColor: '2f' },
  Zero: { name: 'Zero', tag: 'zero', OpacityColor: '00' }
};
